export function getRandom (): number {
  return Math.floor(Math.random() * 101) // Returns a random integer [0 ... 100]
}
